import React from "react";
import Typography from "@mui/material/Typography";
import MarkEmailReadTwoToneIcon from "@mui/icons-material/MarkEmailReadTwoTone";

const MailInviate = ({classes}) => (
	<section className={classes.panel}>
		<header className={classes.panelHeader}>
			<div>
				<Typography className={classes.panelTitle}>Mail inviate</Typography>
				<Typography className={classes.panelSubtitle}>
					Archivio delle comunicazioni no-reply inviate agli utenti.
				</Typography>
			</div>
		</header>

		<div className={classes.emptyState}>
			<MarkEmailReadTwoToneIcon fontSize="large"/>
			<Typography>
				Storico mail in preparazione.
			</Typography>
		</div>
	</section>
);

export default React.memo(MailInviate);
